module.exports = __webpack_public_path__ + "a2a8cd620bac996fdfd060f44eaa2a86.svg";